<app-toolbar-section [label]="'app.__MAP_UNIT_SYSTEM' | AsyncLang | async">

  <app-toolbar-select-item [label]="'station.__METRIC' | AsyncLang | async" [selected]="unitSystem() === 0" (select)="selectUnitSystem(0)"/>
  <app-toolbar-select-item [label]="'station.__IMPERIAL' | AsyncLang | async" [selected]="unitSystem() === 1" (select)="selectUnitSystem(1)"/>

</app-toolbar-section>

<app-toolbar-section [label]="'app.__MAP_PRESSURE_UNIT' | AsyncLang | async">

  <app-toolbar-select-item label="Mbar" [selected]="pressureUnit() === 0" (select)="selectUnitPressure(0)"/>
  <app-toolbar-select-item label="Inhg" [selected]="pressureUnit() === 1" (select)="selectUnitPressure(1)"/>
  <app-toolbar-select-item label="Mmhg" [selected]="pressureUnit() === 2" (select)="selectUnitPressure(2)"/>

</app-toolbar-section>

<app-toolbar-section [label]="'settings.__WIND_UNIT' | AsyncLang | async">

  <app-toolbar-select-item label="km/h" [selected]="windUnit() === 0" (select)="selectUnitWind(0)"/>
  <app-toolbar-select-item label="mph" [selected]="windUnit() === 1" (select)="selectUnitWind(1)"/>
  <app-toolbar-select-item label="m/s" [selected]="windUnit() === 2" (select)="selectUnitWind(2)"/>
  <app-toolbar-select-item label="Beaufort" [selected]="windUnit() === 3" (select)="selectUnitWind(3)"/>
  <app-toolbar-select-item label="Noeuds" [selected]="windUnit() === 4" (select)="selectUnitWind(4)"/>

</app-toolbar-section>
